import ENDPOINT from "./Endpoint";

// apiConfig.js
const API_BASE_URL = `${ENDPOINT}/api/v1`;

export default API_BASE_URL;
